var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-2",
    attrs: {
      headers: _vm.headers,
      items: _vm.checklist,
      loading: _vm.loading,
      "no-data-text": _vm.$t("AddToTable"),
      "loading-text": "",
      "items-per-page-text": _vm.rowsPerPageText,
      "items-per-page-items": _vm.allRows ? _vm.allRows : _vm.rowsPerPageItems,
      "header-props": { sortIcon: _vm.sortIcon },
      "footer-props": {
        prevIcon: _vm.allRows ? null : _vm.prevIcon,
        nextIcon: _vm.allRows ? null : _vm.nextIcon
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c("tr", [
              _c("td", { staticClass: "text-xs-left" }, [
                _vm._v(_vm._s(props.item.label))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-xs-left" }, [
                _vm._v(_vm._s(props.item.type))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-xs-left" }, [
                _vm._v(_vm._s(props.item.required ? "True" : "False"))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-xs-left" }, [
                _vm._v(_vm._s(Number(props.item.index)))
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "text-xs-left" }, [
                _vm._v(_vm._s(props.item.value ? props.item.value : "Empty"))
              ]),
              _vm._v(" "),
              !_vm.editionDisabled
                ? _c(
                    "td",
                    [
                      _c("app-datatable-action-buttons", {
                        attrs: {
                          "user-can-edit": !props.item.value,
                          "user-can-delete": !props.item.value
                        },
                        on: {
                          edit: function($event) {
                            return _vm.$emit("editItem", props.item)
                          },
                          delete: function($event) {
                            return _vm.$emit("removeItem", props.item)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          ]
        }
      },
      {
        key: "pageText",
        fn: function(props) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(props.pageStart) +
                " - " +
                _vm._s(props.pageStop) +
                " " +
                _vm._s(_vm.$t("tables.Of")) +
                "\n    " +
                _vm._s(props.itemsLength) +
                "\n  "
            )
          ]
        }
      },
      {
        key: "no-data",
        fn: function() {
          return [_vm.loading ? _c("div") : _vm._e()]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c071b4e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c071b4e0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Activities/TaskTypes/Photos/PhotoLabelTableCreate.vue
// module id = null
// module chunks = 